export enum ConfigFileUploadAs {
    SignUpPageImage = "SignUpPageImage",
    HomePageImage = 'HomePageImage'
}